module.exports = __webpack_public_path__ + "img/d-shzl.05990f64.png";